<template>
  <div>
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="saveAllocationCarFee"
          v-permission="'admin:dispatch:chefeitanfen:auto'"
          >保存
        </el-button>
      </div>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="true"
      :formConfig="queryCondditionDatas"
    >
      <template #dispatchId>
        <el-form-item>
          <el-button
            size="small"
            class="glo_btnItems glo_bgcMainColor"
            @click="getData()"
            >查询</el-button
          >
        </el-form-item>
      </template>
    </queryCondition>
    <el-form label-position="left" inline v-permission="'admin:dispatch:chefeitanfen:auto'">
      <el-form-item label="总费用" label-width="100px">
        <el-input v-model="form.allocationTotalAmount"></el-input>
      </el-form-item>
      <el-form-item label="分摊方式" label-width="100px">
        <el-select v-model="form.confFormulaAllocationCarFeeId" filterable>
          <el-option
            v-for="formula in formulas"
            :key="formula.formulaId"
            :label="formula.formulaName"
            :value="formula.formulaId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button
          size="small"
          class="glo_btnItems glo_bgcMainColor"
          @click="allocationCarFee"
          >自动摊分</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      :isselection="false"
    >
      <template #allocationCost="{ row }">
        <el-input v-model="row.allocationCost" placeholder="请输入"></el-input>
      </template>
    </mytable>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    queryCondition,
    queryBtns,
    mytable,
  },
  props: {
    dispatchId: {},
  },
  data() {
    return {
      pageGroupName: "AllocationCarFee", //  页面标识
      reportFiledsNumber: "admin_dispatch_car_fee_list_v5", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
      formulas: [],
      form: {},
      //immediate:true
    };
  },
  mounted() {
    this.getFormulas();
    this.queryCondditionDatas = [
      {conditonKey:'dispatchId',conditonVal:this.dispatchId}
    ]
  },
  methods: {
    async getFormulas() {
      const res = await this.$API.runList({
        number: "down_list_formula_allocation_v5",
      });
      this.formulas = res;
    },
    async allocationCarFee() {
      const params = {};
      this.queryCondditionDatas.map((item) => {
        params[item.conditonKey] = item.conditonVal;
      });
      this.$API
        .allocationCarFee({
          ...params,
          ...this.form,
        })
        .then((res) => {
          this.$message.success("摊分成功");
          const data = res.data.result;
          for (let row of this.tableData) {
            const cost = data.filter(
              (item) => item.waybillSplitId == row.waybillSplitId
            );
            if (cost && cost.length > 0) {
              row.allocationValue = cost[0].allocationValue;
              row.allocationCost = cost[0].allocationCost;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("保存失败：" + err.data.message);
        });
    },
    async saveAllocationCarFee() {
      const params = {};
      this.queryCondditionDatas.map((item) => {
        params[item.conditonKey] = item.conditonVal;
      });
      this.$API
        .saveAllocationCarFee({
          ...params,
          ...this.form,
          waybillSplistInfos: this.tableData,
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.form = {};
        })
        .catch((err) => {
          this.$message.error("保存失败：" + err.data.message);
        });
    },
  },
};
</script>

<style>
</style>